// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3gbg2","savePackageButton":"ClientWallet_savePackageButton__1vGM-"};